import React, { createContext, useState, useEffect, useCallback } from 'react';
import { loginApi, logoutApi, meApi, verifyTwoFactorApi } from '../api/auth.api';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await meApi();
      setUser(data.data);
    } catch (err) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  // ذخیره‌ی نشست پس از ورود کامل (رمز + در صورت نیاز کد دو مرحله‌ای)
  const completeSession = (session) => {
    localStorage.setItem('accessToken', session.accessToken);
    localStorage.setItem('refreshToken', session.refreshToken);
    setUser(session.user);
    return session.user;
  };

  /*
   * خروجی:
   *  { step: 'DONE', user }                       ورود کامل
   *  { step: 'CODE', twoFactorToken }             باید کد برنامه‌ی احراز هویت وارد شود
   *  { step: 'SETUP', setupToken }                باید ورود دو مرحله‌ای فعال شود (اجباری)
   */
  const login = async (email, password) => {
    const { data } = await loginApi(email, password);
    const result = data.data;

    if (result.requiresTwoFactor) return { step: 'CODE', twoFactorToken: result.twoFactorToken };
    if (result.requiresTwoFactorSetup) return { step: 'SETUP', setupToken: result.setupToken };

    return { step: 'DONE', user: completeSession(result) };
  };

  const verifyTwoFactor = async (twoFactorToken, code) => {
    const { data } = await verifyTwoFactorApi(twoFactorToken, code);
    return { step: 'DONE', user: completeSession(data.data), backupCodesRemaining: data.data.backupCodesRemaining };
  };

  const logout = async () => {
    try {
      await logoutApi();
    } catch (err) {
      // در صورت خطا هم اطلاعات محلی پاک می‌شود
    }
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, verifyTwoFactor, completeSession, reloadUser: loadUser }}>
      {children}
    </AuthContext.Provider>
  );
}


